import React from "react";

function Services({ Services }) {
  // console.log(services);
  return (
    <div>
      <section className="services" id="services">
        <h2>our services</h2>
        <div className="grid-2">
          {Services.map((service) => (
            <div key={service.id}>
              <figure>
                <h4>{service.title}</h4>
                <p>{service.description}</p>
              </figure>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Services;
